export default "__VITE_ASSET__DULwv7A3__"